/* eslint-disable
 no-eq-null,
 */
import angular from 'angular'
import moment from 'moment'
import _ from 'lodash'
import fp from 'lodash/fp'
import ContractService from '../../services/contract/contract'

export default navbarCtrl

/** @ngInject */
function navbarCtrl($rootScope, $scope, $state, $uibModal, $window, $anchorScroll, $location, $cookies, AlertManager, smoothScroll,
                    ReportManager, PermPermissionStore, DeviceChecker, PotManager, gaEventsService, userCommunityService, ContractService,
                    ContractStatus, PrmUtilsService, DataAccessVariables, ErrorCatcher, features, userInfo) {
    let lastId = null
    $scope.gaEventsService = gaEventsService
    $scope.navCollapsed = DeviceChecker.isMobile()
    $scope.userCommunityInfo = {}
    $scope.userCommunityCount = 0
    $scope.showNavOnMobile = $state.current.data.showNavOnMobile
    $scope.state = $state
    $scope.self = $scope
    $scope.isMobile = DeviceChecker.isMobile
    $scope.isTab = DeviceChecker.isTab

    if (userInfo) {
        $scope.userInfo = userInfo
        $scope.userInfo.hasContracts = $scope.userInfo.contracts.length > 0
        $scope.report = ReportManager
        $scope.newReport = {}
        $scope.latestReport = {}
        $scope.pot = PotManager.getPotBalance()
        PotManager.watch((newPot) => {
            $scope.pot = newPot
        })

        $scope.activeContracts = $scope.userInfo.contracts

        $scope.changeContract = function (newContract) {
            if (!newContract) {
                userInfo.contractSelected = fp.flow(
                    fp.filter((c) => c.status !== ContractStatus.resilie),
                    fp.first
                )(userInfo.contracts)
            } else {
                userInfo.contractSelected = newContract
            }
            $scope.contractSelected = userInfo.contractSelected
            if (lastId && (lastId !== userInfo.contractSelected.id)) {
                return $state.go($state.current, { contractId: userInfo.contractSelected.id }, { reload: true })
            }
            return lastId = userInfo.contractSelected.id
        }

        const check525Date = function (date) {
            let targetDate
            if (moment().date() < 6) {
                targetDate = moment()
          .subtract(1, 'months')
          .date(25)
          .startOf('day')
          .toISOString()
                if (moment(date).isBefore(targetDate)) {
                    return true
                }
            }

            if (moment().date() > 24) {
                targetDate = moment()
          .date(25)
          .startOf('day')
          .toISOString()
                if (moment(date).isBefore(targetDate)) {
                    return true
                }
            }
            return false
        }

        if (userInfo.contractSelected) {
            userInfo.contractSelected.isLinky = PrmUtilsService.isLinky(userInfo.contractSelected.prm.metter_kind)
            userInfo.contractSelected.isLinkyCommunicating = userInfo.contractSelected.prm && userInfo.contractSelected.prm.communicating
            if (!userInfo.contractSelected.isLinkyCommunicating) {
                ReportManager.updateContract(userInfo.contractSelected)
                if (check525Date(userInfo.contractSelected.lastReadings != null ? userInfo.contractSelected.lastReadings[0].end_date : undefined)) {
                    ReportManager.updateClass('input')
                }
            }
        }
    }

    $scope.logout = function () {
        AlertManager.clearAlerts()
        return $state.go('logout', {}, { reload: true })
    }

    $scope.isActive = (state) => $state.is(state) || $state.includes(state)

    $scope.hasParentState = (parent) => {
        return $state.current.parent != null ? $state.current.parent.includes(parent) : undefined
    }

    $scope.isSelectedContractActive = () => userInfo.contractSelected.status !== ContractStatus.resilie

    $scope.scrollDownIfAnonymous = function () {
        if (!$scope.isClient && $state.is('landing')) {
            return smoothScroll(document.getElementById('menu'))
        }
    }

    __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
    .then(() => {
        $scope.isClient = true
    }))

    $rootScope.$on('$stateChangeStart', () =>
    __guard__(PermPermissionStore.getStore().client, (x1) => x1.validatePermission()
    .then(() => {
        $scope.isClient = true
    }))
  )

    $scope.openContactModal = () =>
    $uibModal.open({
        animation: true,
        controller: 'contactModalCtrl',
        template: require('../contactModal/contactModal.jade')(),
        resolve: {
            contractSelected() {
                return $scope.contractSelected
            },
            userInfo() {
                return $scope.userInfo
            },
        },
    })


    $scope.scrollDecouvrir = function () {
        $location.hash('decouvrir')
        return $anchorScroll()
    }

    $scope.toogleNavCollapsed = function () {
        if (DeviceChecker.isMobile()) {
            $scope.navCollapsed = !$scope.navCollapsed
        }
        return true
    }

    $scope.getHeaderHeight = function () {
        let headerHeight = 0
        for (const header of Array.from(angular.element('.stickBelow'))) {
            headerHeight += header.getBoundingClientRect().height
        }
        return headerHeight
    }

    $scope.getFooterHeight = function () {
        let footerHeight = 0
        for (const footer of Array.from(angular.element('footer'))) {
            footerHeight += footer.getBoundingClientRect().height
        }
        for (const foldBlock of Array.from(angular.element('#fold-bottom'))) {
            footerHeight += foldBlock.getBoundingClientRect().height
        }
    // Super dirty : only works with footerHeight + 2px ?!
        return footerHeight + 2
    }

    const openUnpaidBalance = () => {
        return DataAccessVariables.get({ variables: 'OVERDUE_THRESHOLD_POPUP' }).$promise
        .then((variables) => ContractService.findFirstUnpaidContract(userInfo.contracts, variables.OVERDUE_THRESHOLD_POPUP))
        .then((unpaidContract) => {
            if (features.unpaidBalancePopup && !$cookies.get('hasDisplayedUnpaidBalancePopup') && unpaidContract) {
                $cookies.put('hasDisplayedUnpaidBalancePopup', true)
                $uibModal.open({
                    animation: true,
                    resolve: { unpaidContract },
                    component: 'unpaidBalanceModal',
                })
            }
        })
        .catch(ErrorCatcher.catchError)
    }

    angular.element($window).bind('resize', () => {
        if (!$scope.$$phase) {
            return $scope.$digest()
        }
    })

    $scope.$watch(
        () => _.get($state, 'current.data.showNavOnMobile'),
        (showNavOnMobile) => {
            $scope.showNavOnMobile = showNavOnMobile
        }
    )

    const fetchCommunityInfo = () => {
        __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
        .then(() => userCommunityService.fetchCommunityInfo())
        .then(() => {
            $scope.userCommunityInfo = userCommunityService.getUserCommunityInfo()
            $scope.userCommunityCount = userCommunityService.getChatsCount() + userCommunityService.getNotificationsCount()
        })
        .catch(() => false))
    }

    const activate = function () {
        openUnpaidBalance()
        fetchCommunityInfo()
    }

    activate()
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/navbar/navbar.js